import { useQuery } from '@tanstack/react-query';
import { fetchTutorials } from '../services/authService';

function normalizeTutorial(item = {}, index = 0) {
  return {
    id: item?.content_id || index + 1,
    title: item?.title || '',
    description: item?.description || '',
    imageUrl: item?.image_url || '',
  };
}

export function useTutorials(selectedLang = 'EN') {
  return useQuery({
    queryKey: ['tutorials', selectedLang],
    queryFn: async () => {
      const { payload } = await fetchTutorials(selectedLang);

      return {
        tutorials: (Array.isArray(payload?.tutorials) ? payload.tutorials : []).map(normalizeTutorial),
        loginTitle: payload?.login_title || 'Sign In',
        skipTitle: payload?.skip_title || 'Skip',
      };
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
